export default {
      id: "search-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#search",
      toString: function () {
        return this.url;
      }
    }